import styled from "styled-components";

export const IconGapLine = styled.div`
  width: 12vw;
  height: 0.17vw;
  border-radius: 60vw;
  background-color: black;
  opacity: ${(props) => props.opacity};
  flex: none;
`